module.exports = __webpack_public_path__ + "img/button_over.d151fd4a.png";